import React from "react";


  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const addressArray = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        const chainId = await window.ethereum.request({ method: 'eth_chainId' });
        if (chainId !== '0x89'){
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x89' }],
          });
        }
        const obj = {
          status: (chainId !== '0x89' ? <span style={{color:'white'}}>Please connect to Polygon </span> :""),
          address: addressArray[0],
        };
        return obj;
      } catch (err) {
        return {
          address: "",
          status: "😥 " + err.message,
        };
      }
    } else {
      return {
        address: "",
        status: (
          <span>
            <p style={{color:'white'}}>
              {" "}
              {" "}
                You must install an Ethereum wallet.
            </p>
          </span>
        ),
      };
    }
  };

   const getCurrentWalletConnected = async () => {
    if (window.ethereum) {
      try {
        const addressArray = await window.ethereum.request({
          method: "eth_accounts",
        });
        const chainId = await window.ethereum.request({ method: 'eth_chainId' });
        if (chainId !== '0x89'){
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x89' }],
          });
        }
        if (addressArray.length > 0) {
          return {
            address: addressArray[0],
            status: (chainId !== '0x89' ? <span style={{color:'white'}}>Please connect to Polygon </span> :""),
          };
        } else {
          return {
            address: "",
            status: (
              <span>
                <p style={{color:'white'}}>
                  
                </p>
              </span>
            ),
          };
        }
      } catch (err) {
        return {
          address: "",
          status: "😥 " + err.message,
        };
      }
    } else {
      return {
        address: "",
        status: (
          <span>
            <p style={{color:'white'}}>
              {" "}
              {" "}
              You must install an Ethereum wallet.
            </p>
          </span>
        ),
      };
    }
  };

   const disconnectWallet = async() => {
    return {
      address: "",
      status:(
        <span>
          <p style={{color:'white'}}>
          </p>
        </span>
      ),
    };
    
  }

  const checkNetworkChange = async() => {
    if(window.ethereum){
      const chainId = await window.ethereum.request({ method: 'eth_chainId' });
      handleChainChanged(chainId);
      console.log(chainId);
        window.ethereum.on("chainChanged", (chainId) => {
    /* do what you want here */
    /* full refresh is recommended */
    console.log(chainId);
    connectWallet();
    })
    }
    

function handleChainChanged(_chainId) {
  // We recommend reloading the page, unless you must do otherwise
  getCurrentWalletConnected()
}
  }

 

  export {disconnectWallet, getCurrentWalletConnected, connectWallet, checkNetworkChange}


  

